var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"navigation-outer"}},[_c('div',{attrs:{"id":"navigation-inner"}},[_vm._t("default",null,{isVisible:_vm.isVisible,toggle:_vm.toggle,expandedClass:_vm.expandedClass})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }